<!--
 * @Author: Gaho
 * @Date: 2024-04-18 14:38:20
 * @LastEditors: Gaho
 * @LastEditTime: 2024-09-17 14:30:30
 * @Description: 主要用于 circle + crash 
-->
<template>
    <CasinoHistoryBodyCell 
        class="flex-[0.6] md:flex-[0.4] text-[#93acd3] cursor-pointer sm:flex-[0.8]" 
        @click="seeRoundDetail()"
    >
        {{ history.num }}
    </CasinoHistoryBodyCell>
    <CasinoHistoryBodyCell
        class="pr-4 inline-flex flex-[0.6] md:flex-[0.4] cursor-pointer sm:flex-[0.8]"
        @click="seeRoundDetail()"
    >
        <span class="bg-[#2a3546] ellipsis rounded-3xl px-2" 
            :style="{color: sMultiColor}"
        >{{
            `x${getFixed(history.multi)}`
        }}</span>
    </CasinoHistoryBodyCell>
    <CasinoHistoryBodyCell 
        class="text-[#ffffff] flex-[2] md:flex-[2] cursor-pointer sm:flex-[2] hash-cell" 
        @click="seeRoundDetail()"
    >
        <span>
            {{ history.hash }}
        </span>
    </CasinoHistoryBodyCell>
</template>

<script lang="ts">
export default defineComponent({ name: 'HistoryTableRow' });
</script>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import {multi2Level} from '@/pages/casino/crashGame/js/crashGame.js';

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        default: () => ({}),
    },
    isMobileMode: Boolean, // 声明出来，否则控制台一直打印 warn 信息 
    userModalControl: Function,
    seeRoundDetail: Function,
});

// ↓ 倍数颜色
const sMultiColor = computed(()=>{
    // console.log("游戏id:", props.history.gameId);
    let {gameId, multi} = props.history; 
    let multiValue = Number(multi);
    if (gameId === 7){ // crash 
        const aColors = ['#ED1D49', '#1BB83D', '']; // #39404B
        const iLevel = multi2Level(multiValue);
        return aColors[iLevel];
    }
    // ↓ 下面这行是原版写法 
    // :class="Number(history.multi) === 53.03 ? 'text-[#ed1d49]' : 'text-[#1bb83d]'"
    if (multiValue == 53.03) return '#ed1d49';
    return '#1bb83d';
});

</script>

<style lang="scss" scoped>
.hash-cell {
    overflow: hidden;
    span {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>